import React from 'react';
import { Container, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import {
  ContactMail,
  Email,
  MapOutlined,
  Phone,
  Telegram,
  YouTube,
} from '@mui/icons-material';
import { FaAppStore, FaGooglePlay, FaVk } from 'react-icons/fa';
import { format } from 'date-fns';
import styles from './Footer.module.scss';

const Footer = () => (
  <div className={styles.footer}>
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item md={3} xs={12}>
          <Box sx={{ mb: 3 }}>
            <img src="img/logo-h-w.svg" alt="logo" />
          </Box>
          <div>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.cbr.ru/finorg/foinfo/?ogrn=1186196015510"
            >
              Включены в Реестр инвестиционных платформ ЦБ РФ
            </a>
          </div>
          <div>
            Принимаем участие в рабочей группе при ЦБ РФ по регулированию
            краудфандинга
          </div>
          <Box
            sx={{
              maxWidth: '150px',
              my: 4,
            }}
          >
            <a rel="noreferrer" href="https://rus-crowd.ru/" target="_blank">
              <img
                data-src="/landing/images/aoip.png"
                alt="aoip"
                data-no-retina=""
                src="img/aoip.png"
              />
            </a>
          </Box>
        </Grid>
        <Grid item md={3} xs={12}>
          <div className={styles.footerColTitle}>Контакты</div>
          <div className={styles.footerListRow}>
            <MapOutlined className={styles.footerListIcon} sx={{ mr: 2 }} />
            <span>
              г. Ростов-на-Дону,
              <br />
              пр-кт Ворошиловский, 62/284, офис 202
            </span>
          </div>
          <div className={styles.footerListRow}>
            <Email className={styles.footerListIcon} sx={{ mr: 2 }} />
            <span>
              <a
                href="mailto:hello@moneyfriends.ru"
                className="text-medium-gray"
              >
                hello@moneyfriends.ru
              </a>
            </span>
          </div>
          <div className={styles.footerListRow}>
            <Phone className={styles.footerListIcon} sx={{ mr: 2 }} />
            <a href="tel:88005504264" className="text-medium-gray">
              8-800-550-42-64
            </a>
          </div>
          <div className={styles.footerListRow}>
            <ContactMail className={styles.footerListIcon} sx={{ mr: 2 }} />
            <span> ООО «Мани Френдс», ИНН/ОГРН 6163209391/1186196015510</span>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <Box sx={{ mb: 3 }}>
            <div className={styles.footerColTitle}>Мы в социальных сетях</div>
            <div className={styles.footerListRow}>
              <Telegram className={styles.footerListIcon} sx={{ mr: 2 }} />
              <a
                href="tg://resolve?domain=moneyfriends_ru"
                target="_blank"
                rel="noreferrer"
              >
                Telegram
              </a>
            </div>
            <div className={styles.footerListRow}>
              <YouTube className={styles.footerListIcon} sx={{ mr: 2 }} />
              <a
                href="https://www.youtube.com/channel/UCv60HxsJWjp5yTKYdBCYupQ"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>
            </div>
            <div className={styles.footerListRow}>
              <FaVk
                className={styles.footerListIcon}
                style={{ marginRight: '16px' }}
              />
              <a
                href="https://vk.com/moneyfriends_ru"
                target="_blank"
                rel="noreferrer"
              >
                Вконтакте
              </a>
            </div>
          </Box>
          <div>
            <div className={styles.footerColTitle}>Наше приложение</div>
            <div className={styles.footerListRow}>
              <FaGooglePlay
                className={styles.footerListIcon}
                style={{ marginRight: '16px' }}
              />
              <a
                href="https://play.google.com/store/apps/details?id=com.project.moneyfriends&hl=ru&gl=US"
                target="_blank"
                rel="noreferrer"
              >
                Google Play
              </a>
            </div>
            <div className={styles.footerListRow}>
              <FaAppStore
                className={styles.footerListIcon}
                style={{ marginRight: '16px' }}
              />
              <a
                href="https://apps.apple.com/ru/app/money-friends/id1460510082#?platform=iphone"
                target="_blank"
                rel="noreferrer"
              >
                App Store
              </a>
            </div>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div className={styles.footerColTitle}>
            Реквизиты номинального счета
          </div>
          <div className={styles.footerListRow}>
            <span>Банк ТОЧКА ПАО БАНКА "ФК ОТКРЫТИЕ"</span>
          </div>
          <div className={styles.footerListRow}>
            <span>КОР 30101810845250000999</span>
          </div>
          <div className={styles.footerListRow}>
            <span>ИНН 6163209391</span>
          </div>
          <div className={styles.footerListRow}>
            <span>КПП 616301001</span>
          </div>
          <div className={styles.footerListRow}>
            <span>БИК 044525999</span>
          </div>
          <div className={styles.footerListRow}>
            <span>Счет 40702810502500046061</span>
          </div>
        </Grid>
      </Grid>
    </Container>
    <Container maxWidth="xl" sx={{ pt: 3 }}>
      ООО «Мани Френдс» использует файлы «cookie» с целью персонализации
      сервисов и повышения удобства пользования веб-сайтом. Если Вы не хотите,
      чтобы Ваши пользовательские данные обрабатывались, пожалуйста, ограничьте
      их использование в своём браузере.
    </Container>
    <Container
      maxWidth="xl"
      sx={{
        textAlign: 'center',
        pt: 3,
      }}
    >
      © Money Friends, {format(new Date(), 'yyyy')}
    </Container>
  </div>
);

export default Footer;
